import { render } from "./EditGroupInvoice.vue?vue&type=template&id=3488bf4a&scoped=true"
import script from "./EditGroupInvoice.vue?vue&type=script&lang=js"
export * from "./EditGroupInvoice.vue?vue&type=script&lang=js"

import "./EditGroupInvoice.vue?vue&type=style&index=0&id=3488bf4a&lang=css"
import "./EditGroupInvoice.vue?vue&type=style&index=1&id=3488bf4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3488bf4a"]])

export default __exports__